module.exports = __webpack_public_path__ + "img/icon-map-implantation-13.7e1e68ae.svg";